import {
  PriceCompareApi,
  PriceCompareCalculateRequest,
  SterWebsiteModelPriceCompareCalculateResult,
  SterWebsiteModelPriceCompareMetadata,
} from "./api";
import apiConfig from "./apiConfig";

export const fetchCalculate = async (
  input: PriceCompareCalculateRequest
): Promise<SterWebsiteModelPriceCompareCalculateResult> => {
  const priceCompareApi = new PriceCompareApi(apiConfig());
  return priceCompareApi.priceCompareCalculate(input);
};

export const fetchMetadata = async (
  medium: string
): Promise<SterWebsiteModelPriceCompareMetadata> => {
  const priceCompareApi = new PriceCompareApi(apiConfig());
  return priceCompareApi.priceCompareMetadata({ medium });
};
